// POS-I186: sign-in returns to the page the visitor asked for. The path travels in router state
// (never in the URL) and is only used when it is a plain in-app path: a redirect to anywhere else
// ("//evil.com", "/\evil.com", "https://x", "javascript:") falls back to the dashboard.

export const DEFAULT_RETURN_PATH = '/dashboard';

const AUTH_PAGES = new Set(['/login', '/register']);

export function safeReturnPath(from: unknown, fallback: string = DEFAULT_RETURN_PATH): string {
  if (typeof from !== 'string' || from.length === 0 || from.length > 2000) return fallback;
  // Check the raw text and its percent-decoded form: '/%2F%2Fevil.com' must not slip through
  let decoded: string;
  try {
    decoded = decodeURIComponent(from);
  } catch {
    return fallback;
  }
  for (const candidate of [from, decoded]) {
    if (!candidate.startsWith('/')) return fallback;
    if (candidate.startsWith('//')) return fallback;
    if (candidate.includes('\\')) return fallback;
    if (/[\u0000-\u001f\u007f]/.test(candidate)) return fallback;
  }
  const pathname = from.split(/[?#]/)[0].replace(/\/+$/, '') || '/';
  if (AUTH_PAGES.has(pathname)) return fallback;
  return from;
}
